const locale = document.getElementById('locale')?.content || 'en';

export default locale;
